import React, {useEffect, useState} from 'react';
import { Button, Paper, Typography } from "@mui/material";
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Platform,
    Pressable,
    TextInput
  } from 'react-native';
import { styled } from '@mui/material/styles';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import Tooltip from '@mui/material/Tooltip';
import CircleIcon from '@mui/icons-material/Circle';
import { ToastContainer, toast } from 'react-toastify';
import {Controlled as CodeMirror} from 'react-codemirror2';
require('codemirror/lib/codemirror.css');
require('codemirror/theme/material.css');
require('codemirror/theme/neat.css');
require('codemirror/mode/xml/xml.js');
require('codemirror/mode/javascript/javascript.js');

const DemoPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    height:'auto',
    padding: theme.spacing(2),
    ...theme.typography.body2,
    textAlign: 'center',
  }));

  

  const options={
    mode: 'application/xml',
    theme: 'xq-light',
    lineNumbers: true,
    lineWrapping: true,
    textAlign:'left'
  }

  const Cancellation =(props:any)=>{
    const [user, setUser]=useState("");
    const [workflow, setWorkflow]= useState("");
    const [response, setResponse] = useState("");
    const [status, setStatus]=useState(false);
    const [statusText, setStatusText]=useState("");
    const [isSubmit, setIsSubmit]= useState(false);
   
   
    var endpoint= "https://"+ process.env.REACT_APP_NURSE_CALL;
    var codeblue_code= process.env.REACT_APP_SECURITY_CODE;

  const configs = {
    method: 'POST',
    headers: {
      accept: 'application/xml'
    }
  };

  
    const handleLookup=()=>{
      
      
     // console.log("workflow:", workflow);
      if(user ==="" || workflow ===""){
        toast.error('🦄 No allowed empty or blank one of the field!', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      }
      else{
        var recipients:any=[];
        if(user.indexOf(',')>-1){
          var nrec = user.split(',');
          recipients.push(nrec);
        }
        else{
          recipients.push(user);
        }
       
        var tnow = Date.now();
        var priority="Critical";
        var message_type="Code Blue";
        var message="Code Blue Cancellation";
        
        for(var i=0; i<recipients.length;i++){

          var action_data ='<?xml version="1.0" encoding="UTF-8"?>'+ 
          '<!DOCTYPE wctp-Operation SYSTEM "http://dtd.wctp.org/wctp-dtd-v1r3.dtd"> <wctp-Operation wctpVersion="wctp-dtd-v1r3">'+ 
          '<wctp-SubmitRequest> <wctp-SubmitHeader submitTimestamp="'+tnow +'">' +
          '<wctp-Originator senderID="https://ip-test.teleport.umms.org/tiger/'+ recipients[i] +
          '" securityCode="'+ codeblue_code+'" />'+ 
          '<wctp-MessageControl messageID="'+workflow +'" isEscalated="false" allowResponse="true" action="Stop" workflowID="'+workflow + 
          '" notifyWhenQueued="true" allowTruncation="true" preformatted="true" deliveryPriority="'+priority +'" alertingSystem="'+ message_type +'" />'+ 
          '<wctp-Recipient recipientID="'+recipients[i]+'"/></wctp-SubmitHeader>'+
          '<wctp-Payload> <wctp-MCR> <wctp-MessageText>'+message + 
          '</wctp-MessageText><wctp-Choice>Accept</wctp-Choice><wctp-Choice>Decline</wctp-Choice>'+
           '</wctp-MCR> </wctp-Payload> </wctp-SubmitRequest> </wctp-Operation>';
           //console.log(action_data);
          fetch(endpoint, {
            method: 'POST',
            body: action_data,
            headers: {
              'Content-Type': 'application/xml'
            }
          })
          .then(response => response.text())
          .then(result => {setResponse(result)})
          .catch(error => { setResponse(error)});
        }
        
    

      }

  

    };
    const resetLookup=()=>{
      setUser("");
      setWorkflow("");
      setIsSubmit(false);
      setResponse("");
    };
    const copyResponse=(e:any)=>{
     // console.log(e);
      navigator.clipboard.writeText(e);
    };
    return(
        <View style={{flexDirection:'row', justifyContent:'flex-start'}}>
             <ToastContainer />
          <View style={{width:'45%',marginLeft:20, flexDirection:'column'}}>
                <DemoPaper square={false} style={{marginTop:20,  height:'100%'}}>
                    <View style={{flexDirection:'column', justifyContent:'flex-start'}}>
                      <View style={{height:40, backgroundColor:'#eef2f7', justifyContent:'center', marginBottom:20, flexDirection:'row'}}>
                          <Text style={{textAlign:'center', alignSelf:'center' , fontWeight:'bold', fontSize:18}}>Code Blue  </Text>
                          <Text style={{textAlign:'center', alignSelf:'center', color:'#EA0029', fontWeight:'bold', fontSize:18}}>Cancellation</Text>
                      </View>
                      <View style={{flexDirection:'column', justifyContent:'flex-start'}}>
                        <View style={{flexDirection:'row', justifyContent:'center',marginBottom:20}}>
                          <Text style={{alignSelf:'center', marginRight:20}}>Recipients :</Text>
                          <TextInput placeholderTextColor={"#969eaa"} placeholder='username1@umm.edu,username2@umm.edu' multiline style={{borderWidth:1,maxHeight:200,padding:5, width:'80%', marginRight:10, alignSelf:'center'}} value={user} onChangeText={e=>setUser(e)}/>
                        </View>
                  
                        <View style={{flexDirection:'row', justifyContent:'center',}}>
                          <Text style={{alignSelf:'center', marginRight:26}}>Workflow :</Text>
                          <TextInput placeholderTextColor={"#969eaa"} placeholder='5102460941__NC Code Blue_5756111514_'  style={{borderWidth:1,maxHeight:200,padding:5, width:'80%', marginRight:10, alignSelf:'center'}} value={workflow} onChangeText={e=>setWorkflow(e)}/>
                        </View>
                      </View>
                        <View style={{flexDirection:'row', justifyContent:'center', marginTop:20}}>
                          <Button style={{}} onClick={handleLookup} variant={"contained"}>Submit</Button>
                          <Button onClick={() => resetLookup()} variant={"outlined"} style={{marginLeft:20}}>Reset</Button>
                        </View>
                     </View>
                </DemoPaper>
                
            </View>
            <View style={{width:'43%', marginLeft:50}}>
              <DemoPaper square={false} style={{marginTop:20, marginLeft:20,  height:'auto'}}>
                  <View style={{flexDirection:'row', justifyContent:'flex-start',height:40, backgroundColor:'#eef2f7', padding:10}}>
                    <Text>Response</Text>
                    
                       {isSubmit && <Pressable onPress={()=>copyResponse(response)} style={{marginLeft:'20%', marginRight:'20%'}}>
                            <Tooltip title="copy to clipboard">
                               <ContentPasteIcon />
                            </Tooltip>
                        </Pressable> }
                        {isSubmit &&  <View style={{flexDirection:'row', marginLeft:100,  justifyContent:'center', alignItems:'center'}}>
                      <CircleIcon style={{color: status === true ? '#12ca93':'#EA0029', fontSize:20, paddingRight:5}}/>  
                        <Text style={{textAlign:'center'}}>{statusText}</Text>

                      </View>  }
                       
                    
                  </View>
                  <View style={{justifyContent:'flex-start', alignSelf:'flex-start'}}>
                  <CodeMirror
                      
                      value={response}
                      options={options}
                      onBeforeChange={(editor, data, value) => {
                        setResponse(value);
                      }}
                      onChange={(editor, data, value) => {
                      }}
  />
                  </View>
              </DemoPaper>
            </View>

        </View>
    )
  };
  export default Cancellation;